import { configureStore } from '@reduxjs/toolkit';
import getprofilesReducer from 'pages/welcomePage/redux/slice';
import registrationReducer from 'pages/Registration/redux/slice';
import loginReducer from 'pages/login/redux/slice';
import editprofileReducer from 'pages/EditProfile/redux/slice';
import EditfamilyReducer from 'pages/EditFamilyDetails/redux/slice';
import editHoroscopeReducer from 'pages/EditHoroscopeDetails/redux/slice';
import editcontactReducer from 'pages/EditContact/redux/slice';
import editPartnerReducer from 'pages/EditDesiredPartnerDetails/redux/slice';
import userDetailsReducer from 'pages/ListView/redux/slice';
import editEducationReducer from 'pages/EditEducationsDetails/redux/slice';
import profileDetailsReducer from 'pages/ProfileView/redux/slice';
import searchResultReducer from 'pages/Search/redux/slice';
import feedbackReducer from 'pages/Feedback/redux/slice';
import helpcenterReducer from 'pages/HelpCenter/redux/slice';
import settingsReducer from 'pages/ManageSettings/redux/slice';
import manageProfileReducer from 'pages/ManageProfile/redux/slice';

// import paymentReducer from 'pages/paymentgateway/redux/slice';
import paymentReducer from 'pages/MemberShip/redux/slice';
// import dashboardReducer from 'pages/Dashboard/redux/slice';

export const store = configureStore({
  reducer: {
    login: loginReducer,
    getprofiles: getprofilesReducer,
    registrations: registrationReducer,
    editprofile: editprofileReducer,
    Editfamily: EditfamilyReducer,
    edithoroscope: editHoroscopeReducer,
    editcontact: editcontactReducer,
    editpartner: editPartnerReducer,
    listDashboard: userDetailsReducer,
    editeducation: editEducationReducer,
    profileView: profileDetailsReducer,
    searchresults: searchResultReducer,
    feedback: feedbackReducer,
    helpcenter: helpcenterReducer,
    settings: settingsReducer,
    manageProfile: manageProfileReducer,

    paymentgateway: paymentReducer
    // Define your reducers here
    // Learn more here: https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
  }
});
